import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
  useRef,
} from "react";
import styles from "./HATVDashboard.module.scss";
import {
  HATV_FLAGGED_KPIS,
  HATV_NAV_LINKS,
} from "../../../constants/dataConstants";
import { useTranslation } from "react-i18next";
import QMonthApproval from "./QMonthApproval/QMonthApproval";
import AwardApproval from "./AwardApproval/AwardApproval";
import { disableEnableScroll } from "../../../utils/disableEnableScroll";
import QTableCustomViewModal from "../../common/QTableCustomViewModal/HATVCustomViewModal";
import Modal from "../../common/Modal/Modal";
import CustomizeDarkIcon from "../../../assets/images/DarkTheme/setting.svg";
import CustomizeLightIcon from "../../../assets/images/LightTheme/setting_icon.svg";
import SeperatorLineDark from "../../../assets/images/DarkTheme/seperator_line.svg";
import SeperatorLineLight from "../../../assets/images/LightTheme/seperator_line.svg";
import { useDispatch } from "react-redux";
import { updateViewHatvId } from "../../../redux/slices/HatvViewSlice";
import { useAppSelector } from "../../../redux/hooks";
import Button from "../../common/Button/Button";
import HatvInvestigation from "../HatvComponent";
import { useLocation } from "react-router-dom";
import {
  useGetMyAwardApprovalQuery,
  useGetMyQMonthApprovalsQuery,
  useGetUsersListByNativeIDsQuery,
} from "../../../redux/services/hatvAwardApprovalAPI";
import CalendarDropdown from "./CalendarDropdown/CalendarDropdown";
import { useGetOptionsListQuery } from "../../../redux/services/optionMasterAPI";
import { skipToken } from "@reduxjs/toolkit/query";
import ErrorInPageScreen from "../../common/ErrorInPageScreen/ErrorInPageScreen";
import {
  useGetHatvViewsListQuery,
} from "../../../redux/services/customizeViewHatvAPI";
import { useGetViewDetailsQuery } from "../../../redux/services/customizeViewAPI";
import AILogoLight from "../../../assets/images/LightTheme/Infinity_Flower.svg";
import AILogoDark from "../../../assets/images/DarkTheme/Infinity_Flower.svg";
import { MonthOptionsContext } from "../../Context/MonthYearOptionsContext";
import ToastMessage from "../../common/ToastMessage/ToastMessage";
import { toastMessageType } from "../../../types/types";
import ExpandIconDark from "../../../assets/images/DarkTheme/expand_icon.svg";
import ExpandIconLight from "../../../assets/images/LightTheme/expand_icon.svg";
import { withUtag } from "../../../utils/analytics";

interface Props {
  showHatvChatbot?: boolean;
}
const HATVDashboard: React.FC<Props> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const AILogo = currentTheme === "light" ? AILogoLight : AILogoDark;
  const viewId: any = useAppSelector(
    (state: any) => state.viewIdDetailsHatv?.viewId
  );
  const applyWithoutSave: boolean = useAppSelector(
    (state: any) => state.viewIdDetailsHatv.applyWithoutSave
  );

  const isOpenChatBot = location.state?.showHatvChatbot;
  const [isDashboardPage, setIsDashboardPage] = useState<boolean>(
    isOpenChatBot || false
  );
  const [viewDetails, setViewDetails] = useState<any>(null);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [savedViews, setSavedViews] = useState<ViewListDataType[]>([]);
  const [loadingView, setLoadingView] = useState(false);
  const CustomizeIcon =
    currentTheme === "dark" ? CustomizeDarkIcon : CustomizeLightIcon;
  const SeperatorIcon =
    currentTheme === "dark" ? SeperatorLineDark : SeperatorLineLight;
  const defaultViewId = viewId?.defaultViewId
    ? viewId?.defaultViewId
    : viewId?.selectedViewId;
  const [isAPIError, setIsAPIError] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const [accountTableData, setAccountTableData] = useState<any>([]);
  const [isLoadingAccountList, setIsLoadingAccountList] = useState(true);
  const [isLoadingViewSwitch, setIsLoadingViewSwitch] = useState(false);
  const [isDeletingView, setIsDeletingView] = useState(false);
  const [isCreatingView, setIsCreatingView] = useState(false);
  const [isStatusUpdate, setIsStatusUpdate] = useState<string>("");

  const ExpandIcon =
    currentTheme === "light" ? ExpandIconLight : ExpandIconDark;
  const scrollableViewRef = useRef<HTMLDivElement | null>(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    message: "",
    type: "" as toastMessageType,
    show: false,
  });

  const setShowToast = (show: boolean) =>
    setToastConfig((prev) => ({ ...prev, show }));

  const initialLink =
    searchParams.get("tab") ||
    localStorage.getItem("selectedHATVLink") ||
    "hatv_q_month_approval";
  const [activeLink, setActiveLink] = useState(initialLink);
  const {
    data: periodData,
    isLoading: optionLoading,
    isError: optionError,
    refetch: refetchOptions,
  } = useGetOptionsListQuery({
    applicationCode: "amw",
    optionMasterName: "myqmonthapproval-monthfilter",
  });

  const optionsData: OptionItem[] = periodData?.body?.options ?? [];

  const monthYearList = useMemo(() => {
    return optionsData.map(({ code }) => code);
  }, [optionsData]);

  const handleAPIError = () => {
    setIsAPIError(true);
    // setAccountTableData([]);
  };

  const [selectedYearMonth, setSelectedYearMonth] = useState<string | null>(
    null
  );
  useEffect(() => {
    if (!selectedYearMonth && monthYearList.length > 0) {
      setSelectedYearMonth(monthYearList[0]);
    }
  }, [monthYearList, selectedYearMonth]);
  const [selectedPYYearMonthValue, setSelectedPYYearMonthValue] =
    useState<string>("");

  const contextValue = {
    optionsData,
    monthYearList,
    selectedYearMonth,
    setSelectedYearMonth,
    selectedPYYear: selectedPYYearMonthValue,
    selectedPYYearMonth: setSelectedPYYearMonthValue,
    isLoading: optionLoading,
    isError: optionError,
    refetchOptions,
  };

  const handleChangeTab = (tabId: string) => {
    setActiveLink(tabId);
    localStorage.setItem("selectedHATVLink", tabId);
  };
  useEffect(() => {
    const link =
      activeLink === "hatv_q_month_approval" ? "hatvqmonth" : "hatvawards";
    localStorage.setItem("selectedLink", link);
  }, [activeLink]);

  const handleSelectedCode = useCallback(
    (value: string) => {
      setSelectedYearMonth(value);
    },
    [selectedYearMonth]
  );
  const {
    data: awardApprovalData,
    isLoading: isAwardApprovalLoading,
    isFetching: isAwardApprovalFetching,
    isError,
    refetch: refetchAwardApproval,
  } = useAwardApprovalData({
    closingMonth: selectedYearMonth ?? "",
  });

  const {
    data: qMonthApprovalData,
    isLoading: isQMonthApprovalLoading,
    isError: isQMonthApprovalError,
    isFetching: isQMonthApprovalFetching,
    refetch: refetchQMonthApproval,
  } = useQMonthAwardApprovalData({
    closingMonth: selectedYearMonth ?? "",
    viewDetails,
    defaultViewId,
    applyWithoutSave,
  });

  const isInitialLoading =
    optionLoading ||
    !selectedYearMonth ||
    isAwardApprovalLoading ||
    isQMonthApprovalLoading;

  // Get the list of all view
  const {
    isLoading: viewListLoading,
    data: viewListData,
    isError: viewListError,
    isFetching: viewListFetching,
  } = useGetHatvViewsListQuery(
    { type: "my-q-month-approval" },
    {
      refetchOnMountOrArgChange: false,
    }
  );

  useEffect(() => {
    setSavedViews(viewListData?.body || []);
  }, [viewListData]);

  // View details aPI
  const {
    data: viewDetailsData,
    isError: viewDetailsError,
    isLoading: viewDetailsLoading,
    isFetching: viewDetailsFetching,
  } = useGetViewDetailsQuery(
    {
      viewId: defaultViewId,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !viewListData || defaultViewId === null,
    }
  );

  useEffect(() => {
    (viewDetailsError || viewListError) && setIsLoadingAccountList(false);
  }, [viewDetailsError, viewListError]);

  useEffect(() => {
    setViewDetails(viewDetailsData?.body?.viewSetting);
  }, [viewDetailsData]);

  const handleModalToggle = () => {
    setModalOpen(!modalOpen);
  };

  useEffect(() => {
    disableEnableScroll(modalOpen);
  }, [modalOpen]);

  // useEffect(() => {
  //   setSavedViews(viewListData?.body || []);
  // }, []);

  useEffect(() => {
    (isError || isQMonthApprovalError) && handleAPIError();
  }, [isError, isQMonthApprovalError]);

  useEffect(() => {
    if (
      (savedViews && savedViews.length >= 1) ||
      !viewListData ||
      (defaultViewId === null && viewId?.selectedViewId === null)
    ) {
      const view = savedViews.filter((view) => view._default);
      const defaultViews = view.sort(
        (a, b) =>
          new Date(b.audit.updatedDate).getTime() -
          new Date(a.audit.updatedDate).getTime()
      );

      // Get the most recent default view
      const recentDefaultView = defaultViews[0];
      if (
        (view && viewId.defaultViewId) ||
        !viewListData ||
        (defaultViewId === null && viewId?.selectedViewId === null)
      ) {
        dispatch(
          updateViewHatvId({
            ...viewId,
            viewIdDetailsHatv: {
              defaultViewId: recentDefaultView?.viewId || null,
              selectedViewId: null,
            },
          })
        );
      }
    }
  }, [savedViews]);

  useEffect(() => {
    const viewUtagObject = {
      event_name: "hatv_view",
      abo_country: localStorage?.getItem('userCountryCode') || '',
      abo_affiliate: localStorage?.getItem('userAffiliateCode') || '',
      user_role: JSON.parse(localStorage.getItem("userRoleType") || "[]"),
      theme_toggle: currentTheme
    };

    withUtag().then((utag) => utag.view(viewUtagObject));
  }, []);

  useEffect(() => {
    if (isStatusUpdate) {
      refetchQMonthApproval();
      setIsStatusUpdate("");
    }
  }, [isStatusUpdate]);

  const handleAPIStatus = (status: string) => {
    setToastConfig({
      message: "",
      type: "" as toastMessageType,
      show: false,
    });
    if (status === "success") {
      setToastConfig({
        show: true,
        message: `Successfully updated award status`,
        type: "success",
      });
    } else if (status === "fail") {
      setToastConfig({
        show: true,
        message: `Failed to update award status. Please try again!`,
        type: "error",
      });
    }
    setIsStatusUpdate(status);
  };

  const handleViewSelection = (selectedView: any) => {
    if (defaultViewId === selectedView) return;
    setIsLoadingViewSwitch(true);
    dispatch(
      updateViewHatvId({
        ...viewId,
        viewIdDetailsHatv: {
          defaultViewId: selectedView,
          selectedViewId: null,
        },
        applyWithoutSave: false,
      })
    );
  };

  useEffect(() => {
    if (qMonthApprovalData || isQMonthApprovalError) {
      setIsLoadingViewSwitch(false);
    }
  }, [qMonthApprovalData, isQMonthApprovalError]);

  const handleInvestigate = () => {
    setIsDashboardPage(true);
  };

  useEffect(() => {
    const checkScroll = () => {
      if (scrollableViewRef.current) {
        const { scrollWidth, clientWidth } = scrollableViewRef.current;
        setIsScrollable(scrollWidth > clientWidth);
      }
    };

    checkScroll();
    window.addEventListener("resize", checkScroll);

    return () => window.removeEventListener("resize", checkScroll);
  }, [savedViews]);

  return (
    <MonthOptionsContext.Provider value={contextValue}>
      {!isDashboardPage ? (
        <div className={`hatv_dashboard ${styles.hatv_dashboard}`}>
          <div className={styles.dashboard_container}>
            <div className={`flex_wrapper ${styles.flex_wrapper}`}>
              <div className={`tab_wrapper ${styles.tab_wrapper}`}>
                {HATV_NAV_LINKS?.map((item, index) => (
                  <div
                    key={index}
                    className={`tab_name ${styles.tab_name} ${item?.mainTabID === activeLink
                        ? `selected ${styles.selected}`
                        : ""
                      }`}
                    onClick={() => handleChangeTab(item?.mainTabID)}
                  >
                    {t(`${item?.mainTabID}`)}
                  </div>
                ))}
              </div>

              {!isInitialLoading && isAPIError ? (
                <div className={styles.error_wrapper}>
                  <ErrorInPageScreen
                    handleClickTryAgain={() => {
                      setIsAPIError(false);
                      refetchAwardApproval();
                      refetchOptions();
                      refetchQMonthApproval();
                    }}
                  />
                </div>
              ) : (
                <>
                  <div className={styles.header_wrapper}>
                    {activeLink === "hatv_q_month_approval" && (
                      <div className={styles.option_container}>
                        <div
                          className={`btn_wrapper ${styles.btn_wrapper} ${styles.left_buttons}`}
                        >
                          <div
                            className={styles.customize_btn}
                            onClick={handleModalToggle}
                          >
                            <img
                              src={CustomizeIcon}
                              alt="settings"
                              className={styles.setting_icon}
                            />
                            <span className={styles.label}>
                              {t("customize")}
                            </span>
                          </div>
                          <img src={SeperatorIcon} alt="seperator" />
                          <div
                            className={`${defaultViewId === null ? "selected_view_btn" : ""} view_btn ${styles.view_btn}`}
                            onClick={() => handleViewSelection(null)}
                          >
                            <span
                              className={`${defaultViewId === null ? styles.active_label : styles.label}`}
                              data-testid="default_view_testId"
                            >
                              {t("default_view")}
                            </span>
                          </div>
                        </div>
                        <div
                          className={`${styles.btn_wrapper} ${styles.scroll_section}`}
                        >
                          <div
                            className={styles.saved_views}
                            ref={scrollableViewRef}
                          >
                            {savedViews?.length > 0 &&
                              savedViews.map((view: any) => (
                                <div
                                  className={`${defaultViewId === view?.viewId ? "selected_view_btn" : ""} view_btn ${styles.view_btn}`}
                                  onClick={() =>
                                    handleViewSelection(view?.viewId)
                                  }
                                  key={view?.viewId}
                                >
                                  <span
                                    className={`${defaultViewId === view?.viewId ? styles.active_label : styles.label}`}
                                  >
                                    {view?.name}
                                  </span>
                                </div>
                              ))}
                          </div>
                          {isScrollable && (
                            <div className={styles.arrow_btn}>
                              <img src={ExpandIcon} alt="<>" />
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div
                      className={`${styles.btn_wrapper} ${styles.right_buttons}`}
                    >
                      <div className={styles.investigate_btn_wrapper}>
                        <Button
                          id="Investigate"
                          onClick={handleInvestigate}
                          label={t("investigate_with_aI")}
                          style="unfilled"
                          isImg={true}
                          iconName={AILogo}
                          themeColor={
                            currentTheme === "light" ? "#1176A9" : "#B2F9FF"
                          }
                          iconSize={22}
                          className={styles.investigate_btn}
                        />
                      </div>
                      <div className={styles.time_selector}>
                        <CalendarDropdown
                          monthYearList={monthYearList}
                          onselectionMonthYear={handleSelectedCode}
                          selectedMonth={selectedYearMonth}
                          isOnlyYear={false}
                          isLoading={isInitialLoading}
                          isError={optionError}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className={styles.content_wrapper}
                    data-testid="content_wrapper_testID"
                  >
                    <div className={`content_inner ${styles.inner_wrapper}`}>
                      <div
                        className={
                          activeLink === "hatv_q_month_approval"
                            ? styles.active_section
                            : styles.hidden_section
                        }
                      >
                        <QMonthApproval
                          data={qMonthApprovalData}
                          isLoading={
                            isInitialLoading ||
                            isLoadingViewSwitch ||
                            isDeletingView ||
                            isCreatingView ||
                            isQMonthApprovalFetching
                          }
                          isError={isQMonthApprovalError}
                          setIsStatusUpdate={handleAPIStatus}
                        />
                      </div>
                      <div
                        className={
                          activeLink === "hatv_award_approval"
                            ? styles.active_section
                            : styles.hidden_section
                        }
                      >
                        <AwardApproval
                          data={awardApprovalData}
                          isAwardApprovalLoading={
                            isInitialLoading || isAwardApprovalFetching
                          }
                          isError={isAPIError}
                          setIsStatusUpdate={handleAPIStatus}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {modalOpen && (
                <Modal showDrawer={modalOpen} onClose={handleModalToggle}>
                  <QTableCustomViewModal
                    onClose={handleModalToggle}
                    savedViews={savedViews}
                    setViewDetails={setViewDetails}
                    // clearPaginationData={clearPaginationData}
                    setIsDeletingView={setIsDeletingView}
                    setIsCreatingView={setIsCreatingView}
                  />
                </Modal>
              )}
            </div>
            <ToastMessage
              message={toastConfig.message}
              toastType={toastConfig.type}
              showToast={toastConfig.show}
              setShowToast={setShowToast}
              customStyles={{
                top: "64px",
              }}
              autoDismissal
            />
          </div>
        </div>
      ) : (
        <div className={styles.hatv_investigation_container}>
          <HatvInvestigation />
        </div>
      )}
    </MonthOptionsContext.Provider>
  );
};

const useAwardApprovalData = ({ closingMonth }: { closingMonth: string }) => {
  const { t } = useTranslation();

  const shouldSkipApprovalQuery = !closingMonth;

  const {
    data: approvalData,
    isLoading: isInitialLoading,
    ...approvalQueryAttrs
  } = useGetMyAwardApprovalQuery(
    shouldSkipApprovalQuery ? skipToken : { closingMonth }
  );

  const nativeIDs = useMemo(
    () =>
      approvalData?.abos
        ?.map((abo) => abo.accountManager?.userNativeId)
        .filter(Boolean) ?? [],
    [approvalData]
  );

  const { data: userDetailsRes, isLoading: isUserListLoading } =
    useGetUsersListByNativeIDsQuery(
      { nativeIDs },
      { skip: nativeIDs.length === 0 }
    );

  const userDetailsMap = useMemo(() => {
    const map = new Map<string, string>();
    userDetailsRes?.body?.forEach((user) => {
      if (user.nativeId) map.set(user.nativeId, user.fullName);
    });
    return map;
  }, [userDetailsRes]);

  const tableRows = useMemo(() => {
    if (!approvalData?.abos) return [];

    return approvalData.abos.map<TableRowData>((abo: any) => {
      const status = abo.awardApproval.finalApprovalStatus;
      const statusName = t(`hatv_view_routing.routing_status.${status}`) || "-";
      const nativeId = abo.accountManager?.userNativeId;
      const managerName = userDetailsMap.get(nativeId ?? "") ?? nativeId ?? "-";

      return {
        ...abo,
        uplineDiamond: abo.uplineDiamond?.name,
        uplinePlatinum: abo.uplinePlatinum?.name,
        manager: managerName,
        status,
        statusName,
        kpis: [],
        roleIndicators: abo.hatvApprovalRoleIndicators,
        routingRoleIndicators: abo.hatvRoutingRoleIndicators,
      };
    });
  }, [approvalData, t, userDetailsMap]);

  return {
    ...approvalQueryAttrs,
    data: tableRows,
    isLoading: isInitialLoading || isUserListLoading,
  };
};

const flaggedKpis = [
  HATV_FLAGGED_KPIS.groupSize,
  HATV_FLAGGED_KPIS.contributorCount,
  HATV_FLAGGED_KPIS.highestPpvInGroup,
  HATV_FLAGGED_KPIS.volumeFluctuation,
  HATV_FLAGGED_KPIS.eomGpv,
  HATV_FLAGGED_KPIS.tenure,
];

const useQMonthAwardApprovalData = ({
  closingMonth,
  defaultViewId,
  viewDetails,
  applyWithoutSave,
}: {
  closingMonth: string;
  defaultViewId: number;
  viewDetails: any;
  applyWithoutSave: boolean;
}) => {
  const { t } = useTranslation();

  const shouldSkipApprovalQuery = !closingMonth;

  const {
    data: approvalData,
    isLoading: isInitialLoading,
    ...approvalQueryAttrs
  } = useGetMyQMonthApprovalsQuery(
    shouldSkipApprovalQuery
      ? skipToken
      : {
        closingMonth,
        payload: {
          viewId: defaultViewId === null ? null : String(defaultViewId),
          viewSetting: applyWithoutSave ? viewDetails : null,
        },
      }
  );

  const nativeIDs = useMemo(
    () =>
      approvalData?.abos
        ?.map((abo) => abo.accountManager?.userNativeId)
        .filter(Boolean) ?? [],
    [approvalData]
  );

  const { data: userDetailsRes, isLoading: isUserListLoading } =
    useGetUsersListByNativeIDsQuery(
      { nativeIDs },
      { skip: nativeIDs.length === 0 }
    );

  const userDetailsMap = useMemo(() => {
    const map = new Map<string, string>();
    userDetailsRes?.body?.forEach((user) => {
      if (user.nativeId) map.set(user.nativeId, user.fullName);
    });
    return map;
  }, [userDetailsRes]);

  const tableRows = useMemo(() => {
    if (!approvalData?.abos) return [];

    return approvalData.abos.map<TableRowData>((abo) => {
      const status = abo.qMonthApproval.approvalStatus;
      const statusName = t(`q_month_approval_status.${status}`) || "-";
      const nativeId = abo.accountManager?.userNativeId;
      const managerName = userDetailsMap.get(nativeId ?? "") ?? nativeId ?? "-";

      return {
        ...abo,
        uplineDiamond: abo?.uplineDiamond?.name || "-",
        uplinePlatinum: abo?.uplinePlatinum?.name || "-",
        flag: abo.hatvKpis.summary?.kpiFlagName || "",
        manager: managerName,
        status,
        statusName,
        kpis: flaggedKpis
          .map<Kpi>(
            (key) =>
              abo.hatvKpis[key] && {
                ...abo.hatvKpis[key],
                kpiName: t(`hatv_kpi_names.${key}`),
                kpiValue: abo.hatvKpis[key]?.kpiValue?.toString(),
              }
          )
          .filter(Boolean),
        qMonthRoleIndicators: abo?.hatvApprovalRoleIndicators,
      };
    });
  }, [approvalData, t, userDetailsMap]);

  return {
    ...approvalQueryAttrs,
    data: tableRows,
    isLoading: isInitialLoading || isUserListLoading,
  };
};
export default HATVDashboard;
